module.exports = __webpack_public_path__ + "static/media/heywow-regular-webfont.eb079140.woff2";